// store.ts
import {proxy} from 'valtio';
import dayjs from 'dayjs';
import {ERROR_MESSAGES} from '@/constants/messages';
import {handleError} from '@/utils/helpers';
import {deleteHistory, getHistorySplit, generateTitle, updateHistoryTitle} from '@/services/api';

// 定义更严格的类型
export interface SSEState<T = any> {
    data: T | null;
    trace: T | null;
    loading: boolean;
    error: Error | null;
    params: Record<string, string>; // 新增参数存储
}

export const sseStore = proxy<SSEState>({
    data: "",
    trace: "",
    loading: false,
    error: null,
    params: {} // 初始化参数存储
});


export interface HistoryItem<T = any> {
    title?: string | null;
    result: T | null;
    id: string;
    createTime: number;
}

export interface HistoryList<T = any> {
    data: HistoryItem<T>[][];
    isLoading: boolean;
    titleLoadingMap: Record<string, boolean>;
    runFetch: (userId: string | undefined) => Promise<void>;
    delItem: (userId: string | undefined, id: string | undefined) => Promise<void>;
    genTitle: (userId: string | undefined, id: string | undefined) => Promise<void>;
    reNameTitle: (userId: string | undefined, id: string | undefined, title: string) => Promise<void>;
}

/**
 * 更新指定ID的历史记录项的标题
 * @param id - 历史记录项的唯一标识
 * @param title - 新的标题
 * @returns 是否成功更新
 */
const updateItemTitle = (id: string, title: string): boolean => {
    for (let i = 0; i < HistoryStore.data.length; i++) {
        for (let j = 0; j < HistoryStore.data[i].length; j++) {
            if (HistoryStore.data[i][j].id === id) {
                HistoryStore.data[i][j].title = title;
                return true;
            }
        }
    }
    return false;
};

export const HistoryStore = proxy<HistoryList<any>>({
    data: [[],[],[]],
    isLoading: false,
    titleLoadingMap: {},
    async runFetch(userId) {
        if (!userId) {
            handleError(null, ERROR_MESSAGES.USER_ID_ERROR);
            return;
        }
        HistoryStore.isLoading = true;

        try {
            const response = await getHistorySplit(userId);
            console.log(46, response.data);
            if (response.data.success) {
                HistoryStore.data = response.data.data;
            } else {
                handleError(response.data.data.message);
            }
        } catch (error) {
            handleError(error);
        } finally {
            HistoryStore.isLoading = false;
        }
    },

    async delItem(userId,id) {
        if (!userId || !id) {
            handleError(null, ERROR_MESSAGES.USER_ID_ERROR);
            return;
        }
        HistoryStore.isLoading = true;
        
        try {
             const response = await deleteHistory(userId, id);
             console.log(62, response.data);
             if (response.data.success) {
                 HistoryStore.data = response.data.data;
             } else {
                 handleError(response.data.data.message);
             }
         } catch (error) {
             handleError(error);
         } finally {
             HistoryStore.isLoading = false;
         }
    },

    async genTitle(userId, id) {
        if (!userId || !id) {
            handleError(null, ERROR_MESSAGES.USER_ID_ERROR);
            return;
        }
        
        // 设置对应id的loading状态
        HistoryStore.titleLoadingMap[id] = true;
        console.log("ready set title map",HistoryStore.titleLoadingMap)

        console.log("genTitle, cur id", id);
        
        try {
             const response = await generateTitle(id);
             console.log('Generate title response:', response.data);
             if (response.data.success) {
                 // 直接更新对应item的title
                 const title = response.data.data;
                 updateItemTitle(id, title);
                 console.log("update title map",HistoryStore.titleLoadingMap , HistoryStore.data);

             } else {
                 handleError(response.data.data?.message || '生成标题失败');
             }
         } catch (error) {
             handleError(error);
         } finally {
             // 清除对应id的loading状态
             delete HistoryStore.titleLoadingMap[id];
         }
      },

    async reNameTitle(userId, id, title) {
        if (!userId || !id || !title) {
            handleError(null, ERROR_MESSAGES.USER_ID_ERROR);
            return;
        }
        
        // 设置对应id的loading状态
        HistoryStore.titleLoadingMap[id] = true;
        
        try {
             const response = await updateHistoryTitle(id, title);
             console.log('Update title response:', response.data);
             if (response.data.success) {
                 // 直接更新对应item的title
                 updateItemTitle(id, title);
             } else {
                 handleError(response.data.message || '更新标题失败');
             }
         } catch (error) {
             handleError(error);
         } finally {
             // 清除对应id的loading状态
             delete HistoryStore.titleLoadingMap[id];
         }
      }
});